<template>
  <div class="SeriesManagement">
    <AppHeader>系列管理</AppHeader>
    <AppBox class="appBox">
      <!--      <TabsChange :tabList="tabList" :cardType="cardType" :stretchType="stretchType">-->
      <!--        <template v-slot:0>-->
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="上级目录">
            <el-cascader
                v-model="filter.classTreeId"
                :show-all-levels="false"
                :options="options"
                :props="{ emitPath: false }"
                clearable
                @change="onSubmit"
            ></el-cascader>
          </el-form-item>
          <!--          <el-form-item label="开课日期">-->
          <!--            <el-date-picker-->
          <!--              style="width: 250px"-->
          <!--              v-model="filter.dateRange"-->
          <!--              value-format="timestamp"-->
          <!--              type="daterange"-->
          <!--              range-separator="至"-->
          <!--              start-placeholder="开始日期"-->
          <!--              end-placeholder="结束日期"-->
          <!--            >-->
          <!--            </el-date-picker>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="状态">-->
          <!--            <el-select-->
          <!--              style="width: 100px"-->
          <!--              v-model="filter.states"-->
          <!--              placeholder="请选择"-->
          <!--              @change="onSubmit"-->
          <!--            >-->
          <!--              <el-option-->
          <!--                v-for="item in 课程状态选项"-->
          <!--                :key="item.value"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              >-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item>
            <el-input
                v-model="filter.keyword"
                placeholder="系列名称 | 老师"
                @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <el-button type="primary" plain @click="handleAddSeries"
                     v-show="this.permissionCode.has('research:subject:manager')"
          >新增系列
          </el-button>
        </div>
      </div>
      <EnterpriseSeriesList></EnterpriseSeriesList>
      <!--        </template>-->
      <!--        <template v-slot:1>-->
      <!--          <UnitSeriesList></UnitSeriesList>-->
      <!--        </template>-->
      <!--      </TabsChange>-->
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
// import TabsChange from "@/components/TabsChange/index.vue";
import EnterpriseSeriesList from "@/pages/SeriesManagement/EnterpriseSeriesList.vue";
// import UnitSeriesList from "@/pages/SeriesManagement/UnitSeriesList.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {SERIES_STATES} from "@/utils/constants";

export default {
  name: "SeriesManagement",
  components: {EnterpriseSeriesList, AppHeader, AppBox},
  data() {
    const 课程状态选项 = Object.keys(SERIES_STATES).map((key) => {
      return {
        value: Number(key),
        label: SERIES_STATES[key],
      };
    });
    return {
      tabList: ["企业系列", "单位系列"],
      cardType: "",
      stretchType: false,
      options: [
        {
          value: null,
          label: "全部",
        },
      ],
      课程状态选项: [
        {
          value: null,
          label: "全部",
        },
        ...课程状态选项,
      ],
    };
  },
  computed: {
    ...mapState("teachingCenter", ["classifyList", "classSubjectListFilter"]),
    // ...mapState("administrativeCenter", ["tenantDepartmentUserList"]),
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.teachingCenter.classSubjectListFilter;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "classSubjectListFilter",
          value,
        });
      },
    },
  },
  async mounted() {
    await this.getClassTree({
      parentId: null,
    });
    this.options = this.options.concat(this.formatData(this.classifyList.data));
    // await this.getTenantDepartmentUser({
    //   roleName: "老师",
    //   page: null,
    //   size: null,
    // });
  },
  methods: {
    // ...mapActions("administrativeCenter", ["getTenantDepartmentUser"]),
    ...mapActions("teachingCenter", ["getClassTree", "getClassSubjectList"]),
    ...mapMutations("teachingCenter", ["clearFilter"]),
    handleAddSeries() {
      // 如果没有分类，跳转至新增分类
      if (this.classifyList.data.length < 1) {
        this.$confirm("您的课程分类为空,请先到课程分类添加!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.$router.push(
              {
                name: "AddClassify",
                params: {
                  type: "add",
                },
              },
              () => {
              }
          );
        });
        return;
        //   如果没有老师，跳转至新增人员
      }
      // else if (this.tenantDepartmentUserList.data.length < 1) {
      //   this.$confirm(
      //       "您的人员库中老师人数为0,请先去人员管理新增老师!",
      //       "提示",
      //       {
      //         confirmButtonText: "确定",
      //         cancelButtonText: "取消",
      //         type: "warning",
      //       }).then(async () => {
      //     await this.$router.push(
      //         {
      //           name: "AddPerson",
      //           params: {
      //             type: "add",
      //           },
      //         },
      //         () => {
      //         }
      //     );
      //   })
      //   return;
      // }
      this.$router.push(
          {
            name: "AddEnterpriseSeries",
            params: {
              type: "add",
              id: 0,
            },
          }
      );
    },
    async onSubmit() {
      const filters = {
        ...this.filter,
        startTime: this.filter.dateRange ? this.filter.dateRange[0] : null,
        endTime: this.filter.dateRange ? this.filter.dateRange[1] : null,
      };
      filters.dateRange = undefined;
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getClassSubjectList({
            ...filters,
            page: 1,
          });
        }
      });
    },
    async onReset() {
      await this.clearFilter();
      await this.getClassSubjectList({
        page: 1,
      });
    },
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        if (item.children) {
          newVal[index] = {
            value: item.id,
            label: item.name,
            children: this.formatData(item.children),
          };
        } else {
          newVal[index] = {
            value: item.id,
            label: item.name,
          };
        }
      });
      return newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.SeriesManagement {
  .appBox {
    min-height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }
  }
}
</style>
